import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

const ClientTableRow = ({ client }) => {

  const doNotAssign = client.attributes.doNotAssign ? client.attributes.doNotAssign.map((u) => u) : "N/A";

  return (
    <tr>
      <td>{client.id}</td>
      <td>{client.attributes.companyName}</td>
      <td>{client.attributes.contactName}</td>
      <td>{doNotAssign}</td>
      <td>{client.attributes.whiteGloves ? "YES" : "NO"}</td>
      <td className="table-buttons">
        <Link to={'/requirements/view/' + client.id} className="view" data-icon="&#xe91a;" data-tooltip="View">view</Link>
        <Link to={'/requirements/edit/' + client.id} className="edit" data-icon="&#xe909;" data-tooltip="Edit">edit</Link>
      </td>
    </tr>
  );
};

ClientTableRow.propTypes = {
  client: PropTypes.object.isRequired
};

export default ClientTableRow;



// WEBPACK FOOTER //
// ./src/components/clients/ClientTableRow.js